"use strict";

import { Button } from "@showitinc/showit-wc";
import React from "react";

class SetupButtonBar extends React.Component {
  static defaultProps = {
    forwardBtnText: "Next",
    backBtnText: "Back",
    allowForward: true,
    allowBack: false,
  };

  _backBtnClick = () => {
    if (this.props.onBack) {
      this.props.onBack();
    }
  };

  _forwardBtnClick = () => {
    if (this.props.onForward) {
      this.props.onForward();
    }
  };

  render() {
    let barStyle = {
      display: "flex",
      justifyContent: "space-between",
      marginTop: 10,
    };

    let backBtnStyle = {
      visibility: this.props.allowBack ? "visible" : "hidden",
    };

    return (
      <div style={barStyle}>
        <Button variant="minimal" style={backBtnStyle} onClick={this._backBtnClick}>
          {this.props.backBtnText}
        </Button>
        <Button
          variant="feature"
          disabled={!this.props.allowForward}
          onClick={this._forwardBtnClick}
        >
          {this.props.forwardBtnText}
        </Button>
      </div>
    );
  }
}

export default SetupButtonBar;
